import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Validator from '../../Common/validator';
import SecondActivity from './secondActivity';


class RootActivity extends Component {
  shouldComponentUpdate = (nextProps) => {
    // eslint-disable-next-line
    if (nextProps.rowShouldUpdate.rootKey == this.props.indexKey || nextProps.rowShouldUpdate.rootKey == 0) {
      return true
    }
    return false;
  };
  componentWillMount = () => {
    //if root activty dont have children add a child
    // eslint-disable-next-line
    if (this.props.rootActivity.seconds.length == 0) {
      this.props.rootActivity.seconds.addField();
    }
    // eslint-disable-next-line
    if (this.props.rootActivityCount == this.props.indexKey && this.props.rootActivity.name.value) {
      this.props.addNewField()
    }
  };
  addSecond = () => {
    this.props.rootActivity.seconds.addField();
  };
  renderSeconds = (seconds, rootkey) => {
    const { styles, setRowShouldUpdate, rowShouldUpdate, isEdit } = this.props;
    return seconds.map((second, i) => {
      return (
        <SecondActivity
          key={i}
          second={second}
          index={i + 1}
          styles={styles}
          rootKey={rootkey}
          setRowShouldUpdate={(thirdKey) => setRowShouldUpdate(i + 1, thirdKey)}
          rowShouldUpdate={rowShouldUpdate}
          // eslint-disable-next-line
          addNewField={i + 1 == seconds.length ? this.addSecond : null}
          secondActivityCount={seconds.length}
          isEdit={isEdit}
        />
      )
    })
  };
  render() {
    const { styles, indexKey, rootSum, rootActivity, setRowShouldUpdate, isEdit } = this.props;
    return (
      <div className="row" style={styles.rootActivityContainer}>
        <div style={styles.headingsRow}>
          <div style={[styles.firstInRootRow]} className="col-sm-4">Aktivitet</div>
          <div className="col-sm-2" style={styles.col}>Enhed</div>
          <div className="col-sm-2" style={styles.col}>Mængde</div>
          <div className="col-sm-2" style={styles.col}>Timer/enhed</div>
          <div className="col-sm-2" style={styles.col}>Sum timer</div>
        </div>
        <div>
          <div style={[styles.firstInRootRow, styles.rootRowName]} className={rootActivity.name.valid ? "col-sm-4" : "col-sm-4 error"}>
            <div style={styles.indexKey}>{indexKey}</div>
            <Validator
              isValid={!rootActivity.name.touched || rootActivity.name.valid}>
              <input
                className="form-control"
                type="text"
                placeholder={!(!rootActivity.name.touched || rootActivity.name.valid) ? rootActivity.name.error : rootActivity.name.initialValue ? rootActivity.name.initialValue : "Aktivitet"}
                style={[styles.rootInputField, styles.inputField, styles.inputFieldName]}
                value={rootActivity.name.value}
                onBlur={(evt) => {
                  // eslint-disable-next-line
                  if (evt.target.value == "" && rootActivity.name.initialValue && isEdit) {
                    evt.target.value = rootActivity.name.initialValue
                  }
                  setRowShouldUpdate();
                  rootActivity.name.onBlur(evt);
                }}
                onChange={(evt) => {
                  setRowShouldUpdate();
                  rootActivity.name.onChange(evt);
                  // if addNewField is a fucntion, then add new field
                  if (this.props.addNewField) this.props.addNewField();
                }}
              />
            </Validator>
          </div>
          <div style={styles.rootSum}>{Math.round(rootSum * 100) / 100}</div>
        </div>
        {this.renderSeconds(rootActivity.seconds, indexKey)}
      </div>
    );
  }
}

RootActivity.propTypes = {
  rootActivity: PropTypes.object.isRequired,
  rootSum: PropTypes.number.isRequired,
  setRowShouldUpdate: PropTypes.func.isRequired,
  rowShouldUpdate: PropTypes.object.isRequired,
  addNewField: PropTypes.func,
  rootActivityCount: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
  isEdit: PropTypes.bool.isRequired
};

export default Radium(RootActivity)


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/rootActivity.jsx